{
	const TEMPLATE_VIEW = 'cro-collection';
	const TAB_PARAM = 'tab';
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	const bindFilterFlyouts = (root) => {
		if (!root.classList.contains('cro-cpg--filters-bar')) return;
		if (root.dataset.cpgFiltersBound === 'true') return;
		root.dataset.cpgFiltersBound = 'true';

		const flyoutQuery = window.matchMedia('(min-width: 801px)');
		let isClosingGroups = false;

		const closeOpenGroups = (exceptHeading = null) => {
			if (isClosingGroups) return;
			isClosingGroups = true;
			root.querySelectorAll('.sidebar__heading.accordion-is-open').forEach((trigger) => {
				if (exceptHeading && trigger === exceptHeading) return;
				trigger.click();
			});
			isClosingGroups = false;
		};

		const onRootClick = (event) => {
			if (!flyoutQuery.matches) return;
			const heading = event.target.closest('.sidebar__heading.js');
			if (!heading || !root.contains(heading)) return;
			closeOpenGroups(heading);
		};

		const onDocumentClick = (event) => {
			if (!root.isConnected) {
				document.removeEventListener('click', onDocumentClick);
				root.removeEventListener('click', onRootClick);
				flyoutQuery.removeEventListener('change', onFlyoutChange);
				return;
			}

			if (!flyoutQuery.matches) return;
			if (event.target.closest('.sidebar__heading')) return;
			if (event.target.closest('.sidebar__navigation__list')) return;
			if (event.target.closest('[data-show-more]')) return;

			closeOpenGroups();
		};

		const onFlyoutChange = (event) => {
			if (!event.matches) closeOpenGroups();
		};

		root.addEventListener('click', onRootClick);
		document.addEventListener('click', onDocumentClick);
		flyoutQuery.addEventListener('change', onFlyoutChange);
	};

	const syncQuickLinkFades = (swiper) => {
		const nav = swiper.el && swiper.el.closest('.cro-cpg__quick-links--swiper');
		if (!nav) return;

		if (swiper.isLocked) {
			nav.classList.remove('is-fade-left', 'is-fade-right');
			return;
		}

		const epsilon = 2;
		const translate = swiper.translate;
		const atStart = translate >= swiper.minTranslate() - epsilon;
		const atEnd = translate <= swiper.maxTranslate() + epsilon;

		nav.classList.toggle('is-fade-left', !atStart);
		nav.classList.toggle('is-fade-right', !atEnd);
	};

	const initQuickLinkSwipers = (scope = document) => {
		if (typeof Swiper === 'undefined') return;

		scope.querySelectorAll('.cro-cpg-swiper').forEach((el) => {
			if (el.swiper) {
				syncQuickLinkFades(el.swiper);
				return;
			}

			new Swiper(el, {
				slidesPerView: 'auto',
				spaceBetween: 5,
				freeMode: true,
				watchOverflow: true,
				on: {
					init: syncQuickLinkFades,
					progress: syncQuickLinkFades,
					setTranslate: syncQuickLinkFades,
					resize: syncQuickLinkFades,
					lock: syncQuickLinkFades,
					unlock: syncQuickLinkFades,
				},
			});
		});
	};

	const tabs = () => document.querySelectorAll('[data-cpg-tab]');

	const findGrid = () => document.querySelector('#cro-collection-grid') || document.querySelector('.cro-cpg');

	const collectionHandleFromUrl = (href) => {
		try {
			const url = new URL(href, window.location.origin);
			const parts = url.pathname.split('/').filter(Boolean);
			const collectionIndex = parts.indexOf('collections');
			if (collectionIndex === -1 || !parts[collectionIndex + 1]) return '';
			return decodeURIComponent(parts[collectionIndex + 1]);
		} catch {
			return '';
		}
	};

	const rewriteCollectionRequest = (input) => {
		const raw = typeof input === 'string' ? input : input instanceof Request ? input.url : null;
		if (!raw) return input;

		let url;
		try {
			url = new URL(raw, window.location.origin);
		} catch {
			return input;
		}

		if (url.origin !== window.location.origin) return input;
		const sectionId = url.searchParams.get('section_id');
		if (!sectionId) return input;

		const root = document.querySelector(`.cro-cpg[data-section-id="${sectionId}"]`);
		const activeUrl = root?.dataset.cpgCollectionUrl;
		if (!root || !activeUrl) return input;

		const next = new URL(activeUrl, window.location.origin);
		url.searchParams.forEach((value, key) => {
			next.searchParams.set(key, value);
		});
		next.searchParams.delete(TAB_PARAM);
		next.searchParams.set('view', root.dataset.cpgView || TEMPLATE_VIEW);
		next.searchParams.set('section_id', sectionId);

		if (typeof input === 'string') return next.toString();
		return new Request(next.toString(), input);
	};

	let fetchPatched = false;
	const patchFetchForTabs = () => {
		if (fetchPatched) return;
		fetchPatched = true;
		const nativeFetch = window.fetch.bind(window);
		// Theme filter AJAX always requests window.location.pathname. Rewrite those
		// section renders onto the active tab collection so the hero URL can stay put.
		window.fetch = (input, init) => nativeFetch(rewriteCollectionRequest(input), init);
	};

	const setActiveTab = (activeTab) => {
		tabs().forEach((tab) => {
			const isActive = tab === activeTab;
			tab.classList.toggle('cro-cch__card--active', isActive);
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
			tab.tabIndex = isActive ? 0 : -1;
		});
		const root = findGrid();
		if (root && activeTab?.id) root.setAttribute('aria-labelledby', activeTab.id);
	};

	const setHeading = (root, title) => {
		const heading = root.querySelector('[data-cpg-heading]');
		if (heading && title) heading.textContent = title;
	};

	const sectionUrl = (href, sectionId, view = TEMPLATE_VIEW) => {
		const url = new URL(href, window.location.origin);
		url.searchParams.delete(TAB_PARAM);
		url.searchParams.set('view', view);
		url.searchParams.set('section_id', sectionId);
		return url;
	};

	const hubHistoryUrl = (sourceHref, handle) => {
		const current = new URL(window.location.href);
		const source = new URL(sourceHref, window.location.origin);
		const next = new URL(current.pathname, window.location.origin);
		source.searchParams.forEach((value, key) => {
			if (key === 'section_id' || key === 'view' || key === TAB_PARAM) return;
			next.searchParams.set(key, value);
		});
		if (handle) next.searchParams.set(TAB_PARAM, handle);
		return `${next.pathname}${next.search}`;
	};

	const applySectionHtml = (root, html, { scrollToGrid = false } = {}) => {
		const doc = new DOMParser().parseFromString(html, 'text/html');
		const nextGrid = doc.querySelector('[data-products-grid]');
		if (!nextGrid) throw new Error('Missing products grid');

		const grid = root.querySelector('[data-products-grid]');
		if (grid) grid.innerHTML = nextGrid.innerHTML;

		const sidebar = root.querySelector('[data-collection-sidebar]');
		const nextSidebar = doc.querySelector('[data-collection-sidebar]');
		const filterToggle = root.querySelector('[data-filters-toggle="filters"]');
		if (sidebar && nextSidebar) {
			sidebar.innerHTML = nextSidebar.innerHTML;
			sidebar.hidden = false;
			if (filterToggle) filterToggle.hidden = false;
		} else if (sidebar && !nextSidebar) {
			sidebar.innerHTML = '';
			sidebar.hidden = true;
			if (filterToggle) filterToggle.hidden = true;
		}

		const activeHolder = root.querySelector('[data-active-filters]');
		const nextActive = doc.querySelector('[data-active-filters]');
		if (activeHolder && nextActive) {
			activeHolder.innerHTML = nextActive.innerHTML;
			activeHolder.parentNode?.classList.toggle('is-hidden', nextActive.innerHTML.trim() === '');
		}

		const quickSlot = root.querySelector('[data-cpg-quick-links-slot]');
		const nextQuick = doc.querySelector('[data-cpg-quick-links-slot]');
		if (quickSlot && nextQuick) {
			quickSlot.innerHTML = nextQuick.innerHTML;
			initQuickLinkSwipers(root);
		}

		if (scrollToGrid && grid) {
			grid.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
		}
	};

	const bindCollectionAjax = (root) => {
		if (root.dataset.cpgAjaxBound === 'true') return;
		root.dataset.cpgAjaxBound = 'true';

		const sectionId = root.dataset.sectionId;
		let abortController = null;

		const loadPage = async (href, { writeHistory = true, scrollToGrid = false } = {}) => {
			const grid = root.querySelector('[data-products-grid]');
			if (!grid || !sectionId) {
				window.location.href = href;
				return;
			}

			abortController?.abort();
			abortController = new AbortController();

			grid.classList.add('is-loading');
			grid.setAttribute('aria-busy', 'true');

			try {
				const response = await fetch(sectionUrl(href, sectionId, root.dataset.cpgView || TEMPLATE_VIEW).toString(), {
					signal: abortController.signal,
				});
				if (!response.ok) throw new Error(response.statusText);

				applySectionHtml(root, await response.text(), { scrollToGrid });
				if (writeHistory) window.history.pushState(null, '', hubHistoryUrl(href, collectionHandleFromUrl(root.dataset.cpgCollectionUrl)));
			} catch (error) {
				if (error?.name === 'AbortError') return;
				window.location.href = href;
			} finally {
				grid.classList.remove('is-loading');
				grid.removeAttribute('aria-busy');
			}
		};

		const switchTab = (tab, writeHistory = true, { moveFocus = true } = {}) => {
			const collectionUrl = tab.dataset.collectionUrl;
			if (!collectionUrl || collectionUrl === '#') return;
			if (tab.classList.contains('cro-cch__card--active') && root.dataset.cpgCollectionUrl === collectionUrl) {
				if (moveFocus) tab.focus();
				return;
			}

			root.dataset.cpgCollectionUrl = collectionUrl;
			root.dataset.cpgView = tab.dataset.cpgView || TEMPLATE_VIEW;
			setActiveTab(tab);
			setHeading(root, tab.dataset.tabTitle);
			if (moveFocus) tab.focus();
			loadPage(collectionUrl, { writeHistory, scrollToGrid: false });
		};

		root.addEventListener('click', (event) => {
			const link = event.target.closest('.cro-cpg__pagination a[href]');
			if (!link || !root.contains(link)) return;
			if (link.getAttribute('href') === '#') return;

			event.preventDefault();
			loadPage(link.href, { scrollToGrid: true });
		});

		root.addEventListener(
			'click',
			(event) => {
				const link = event.target.closest('[data-filter-update-url]');
				if (!link || !root.contains(link)) return;
				const href = link.getAttribute('href');
				if (!href || href === '#') return;

				event.preventDefault();
				event.stopPropagation();
				loadPage(href);
			},
			true
		);

		const initialTab = Array.from(tabs()).find((tab) => tab.classList.contains('cro-cch__card--active')) || tabs()[0];
		if (initialTab?.dataset.collectionHandle) {
			root.dataset.cpgDefaultHandle = initialTab.dataset.collectionHandle;
		}

		window.addEventListener('popstate', () => {
			if (!root.isConnected) return;
			const handle = new URL(window.location.href).searchParams.get(TAB_PARAM) || root.dataset.cpgDefaultHandle;
			const matchingTab = handle
				? Array.from(tabs()).find((tab) => tab.dataset.collectionHandle === handle)
				: null;

			if (matchingTab) {
				root.dataset.cpgCollectionUrl = matchingTab.dataset.collectionUrl;
				root.dataset.cpgView = matchingTab.dataset.cpgView || TEMPLATE_VIEW;
				setActiveTab(matchingTab);
				setHeading(root, matchingTab.dataset.tabTitle);
			}

			loadPage(window.location.href, { writeHistory: false });
		});

		root.switchCollectionTab = switchTab;
		root.loadCollectionPage = loadPage;
	};

	let tabsBound = false;
	const bindHeroTabs = () => {
		if (tabsBound) return;
		tabsBound = true;

		document.addEventListener('click', (event) => {
			const tab = event.target.closest('[data-cpg-tab]');
			if (!tab) return;

			const href = tab.getAttribute('href');
			if (!href || href === '#') {
				event.preventDefault();
				return;
			}

			const root = findGrid();
			if (!root?.switchCollectionTab) return;

			event.preventDefault();
			root.switchCollectionTab(tab);
		});

		document.addEventListener('keydown', (event) => {
			const tab = event.target.closest('[data-cpg-tab]');
			if (!tab) return;
			if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') {
				return;
			}

			const items = Array.from(tabs());
			if (!items.length) return;

			event.preventDefault();
			const index = items.indexOf(tab);
			let nextIndex = index;
			if (event.key === 'ArrowRight') nextIndex = (index + 1) % items.length;
			if (event.key === 'ArrowLeft') nextIndex = (index - 1 + items.length) % items.length;
			if (event.key === 'Home') nextIndex = 0;
			if (event.key === 'End') nextIndex = items.length - 1;

			const root = findGrid();
			const nextTab = items[nextIndex];
			if (root?.switchCollectionTab) root.switchCollectionTab(nextTab);
			else nextTab.focus();
		});
	};

	const restoreTabFromQuery = (root) => {
		const handle = new URL(window.location.href).searchParams.get(TAB_PARAM);
		if (!handle) return;

		const tab = Array.from(tabs()).find((item) => item.dataset.collectionHandle === handle);
		if (!tab || tab.classList.contains('cro-cch__card--active')) return;
		root.switchCollectionTab(tab, false, { moveFocus: false });
	};

	const init = (scope = document) => {
		scope.querySelectorAll('.cro-cpg--filters-bar').forEach(bindFilterFlyouts);
		scope.querySelectorAll('.cro-cpg').forEach((root) => {
			bindCollectionAjax(root);
			if (tabs().length) {
				patchFetchForTabs();
				restoreTabFromQuery(root);
			}
		});
		initQuickLinkSwipers(scope);
		if (tabs().length) bindHeroTabs();
	};

	init();

	document.addEventListener('shopify:section:load', (event) => {
		init(event.target);
	});
}
